import { ComboEmpresa } from './combo-empresa';

export class FilterEmpresa {
	empresa: ComboEmpresa;
}